export default {"src":"/_next/static/media/A.af288da6.svg","height":18,"width":18};